import { Layout, theme } from 'antd';

import ProgramIntroduction from '../PatientProgramIntroduction';
import LayoutFooter from './LayoutFooter';
import LayoutHeader from './LayoutHeader';

const { Content } = Layout;

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Layout
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Layout style={{ flex: '1 0 auto' }}>
        <Content
          style={{
            // margin: '24px',
            overflow: 'auto',
          }}
        >
          <div
            style={{
              minHeight: '100%',
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
            className="pb-6"
          >
            <LayoutHeader />
            <div className="mx-auto max-w-screen-xl px-5">
              {children}
              <ProgramIntroduction />
            </div>
          </div>
        </Content>
      </Layout>
      <LayoutFooter />
    </Layout>
  );
};
export default MainLayout;
